export const UNLIMITED_RELEASE_DATE = '2025-02-24';
export const UNLIMITED_EXPIRATION_DATE = '2025-03-03';
export const UNLIMITED_LOCAL_STORAGE_KEY = 'letroso-unlimited-last-games';
